import {EntityCollectionServiceBase, EntityOp} from "@ngrx/data";
import {HttpModelConverter} from "../converter/httpModel.converter";
import {DefaultDataservice} from "../../../store/core/dataservice/default.dataservice";
import {ServiceErrorCodes} from "./error/service.error";
import {EntityCollectionFindOneService} from "./entityCollectionFindOneService";
import {filter} from "rxjs/operators";

export abstract class EntityCollectionFindOneByAttributeService<T, C extends HttpModelConverter<T>> extends EntityCollectionFindOneService<T, C> {

    protected readonly entityDataService: DefaultDataservice<T>;

    protected entityLoaded(entity: T) {
    }

    protected constructor(serviceName: string, entityCollectionServiceBase: EntityCollectionServiceBase<T>, dataService: DefaultDataservice<T>, converter: C) {
        super(serviceName, entityCollectionServiceBase, converter);
        this.entityDataService = dataService;

        // Refresh pagination when any entity is deleted, added or updated
        this.entityActions$.pipe(
            filter((entityAction) =>
                //TODO handle save
                entityAction.payload.entityOp === EntityOp.REMOVE_ALL
                || entityAction.payload.entityOp === EntityOp.REMOVE_ONE
                || entityAction.payload.entityOp === EntityOp.REMOVE_MANY
            ))
            .subscribe(() => {
                if (this.value) {
                    this.loadEntity(this.value);
                }

            });
    }

    reloadEntity(): Promise<T> {
        return this.loadEntity(this.value);
    }

    loadEntity(value: any): Promise<T> {
        const attributeName = this.getAttributeName();
        this.value = value;
        this.setLoading(true);
        this.setError(undefined);

        const path = attributeName === "id" ? ('' + value) : 'one-by-' + this.getAttributeName() + "/" + value;
        return new Promise((resolve, reject) => {
            this.entityDataService.getOneWithQuery(this.buildFullPath(path)).toPromise()
                .then((data) => {
                    const convertedData = this.converter.convert(data);
                    if (!this.isDtoSummary()) {
                        this.entityCollectionServiceBase.updateOneInCache(convertedData);
                        this.entityCollectionServiceBase.addOneToCache(convertedData);
                    }
                    let ngrxData = convertedData;
                    if (this.isDtoSummary()) {
                        (ngrxData as any).summary = data;
                    }
                    this.id = this.entityCollectionServiceBase.selectId(ngrxData);
                    this.entityLoaded(convertedData);
                    resolve(convertedData);
                })
                .catch((e) => {
                    this.setError(e);
                    reject(e);
                })
                .finally(() => {
                    this.setLoading(false);
                    this.setError(undefined)
                });
        });
    }

    protected abstract getAttributeName(): string;

    private loadById(id: string | number): Promise<T> {
        this.id = id;
        return new Promise((resolve, reject) => {
            this.entityDataService.getOneWithQuery('' + id).toPromise()
                .then((data) => {
                    this.entityCollectionServiceBase.updateOneInCache(data);
                    this.entityCollectionServiceBase.addOneToCache(data);
                    resolve(data);
                })
                .catch(() => {
                    const error = {
                        code: ServiceErrorCodes.SERVICE_ERROR_CODE_UNKNOWN_ERROR
                    };
                    reject(error)
                })
        });


        return new Promise((resolve, reject) => {


            this.entityCollectionServiceBase.getByKey(id, {
                tag: this.serviceName
            }).toPromise()
                .then((data) => {
                    resolve(data);
                })
                .catch((e) => {
                    reject(e)
                });
        });
    }

    private loadByAttribute(value: any): Promise<T> {
        return new Promise((resolve, reject) => {
            this.entityDataService.getOneWithQuery(this.buildFullPath('one-by-' + this.getAttributeName() + "/" + value)).toPromise()
                .then((data) => {
                    this.entityCollectionServiceBase.updateOneInCache(data);
                    this.entityCollectionServiceBase.addOneToCache(data);
                    resolve(data);
                })
                .catch(() => {
                    const error = {
                        code: ServiceErrorCodes.SERVICE_ERROR_CODE_UNKNOWN_ERROR
                    };
                    reject(error)
                })
        });
    }

    private buildFullPath(path: string): string {
        return path + (this.isDtoSummary() ? '/summary' : '');
    }


}
